<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Conta Corrente do Cliente</h3>
        </div>
      </div>

      <a
        href="#"
        class="btn-float btn-primary"
        v-b-tooltip.hover
        title="Gerar relatório"
        v-on:click="OpenModalReport($event)"
      >
        <i class="fa fa-download"></i>
      </a>

      <div>
        <d-col class="row" style="position: initial !important">
          <!-- Loader -->
          <d-card
            v-if="loading"
            class="card-small go-stats"
            style="width: 100%; position: initial !important"
          >
            <loader :is-loading="loading" />
          </d-card>
          <d-card
            v-else
            class="card-small go-stats"
            style="position: initial !important"
          >
            <!-- Calendar -->

            <d-card-body>
              <calendar
                :defaultDate="releaseDate"
                :events="events"
                v-on:datesRenderClick="AlterMonth($event)"
                v-on:dayClick="OpenDetailsDay($event)"
                v-on:titleClick="OpenDetailsTitle($event)"
              />
            </d-card-body>
          </d-card>
        </d-col>
      </div>
    </div>
    <b-modal
      id="mReport"
      title="Relatório de Conta Corrente"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <ValidationObserver tag="form" ref="reportValidationForm">
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Data inicial</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <date-field
                v-model="initialDate"
                :inputClass="validatedReportForm | showValidateError(invalid)"
              />
              <div class="invalid-feedback d-block" v-if="validatedReportForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Data final</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <date-field
                v-model="endDate"
                :inputClass="validatedReportForm | showValidateError(invalid)"
              />
              <div class="invalid-feedback d-block" v-if="validatedReportForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
        </d-form-row>
      </ValidationObserver>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="GetReport()"
          :disabled="loadingReport"
        >
          <template v-if="!loadingReport">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingReport"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { htmlEscape } from "@fullcalendar/core";
import calendar from "../common/calendar";
import dateField from "../common/date-field";
export default {
  name: "merchant-checking-account",
  components: {
    calendar,
    dateField,
  },
  data: function () {
    return {
      loading: false,
      loadingReport: false,
      validatedReportForm: false,
      releaseDate: null,
      initialDate: null,
      endDate: null,
      events: [],
    };
  },
  computed: {},
  watch: {
    releaseDate: function (nv, old) {
      if (nv != old) this.ListCheckingAccount();
    },
  },
  mounted() {
    this.idMerchant = this.$route.params.idMerchant;
  },
  methods: {
    OpenDetails: function (date) {
      this.$router.push({
        name: "merchant-checking-account-details",
        query: {
          initialDate: this.$options.filters.date(date, "YYYY-MM-DD"),
        },
      });
    },
    OpenDetailsDay: function (e) {
      this.OpenDetails(e.date);
    },
    OpenDetailsTitle: function (e) {
      this.OpenDetails(e.event.start);
    },
    AlterMonth: function (e) {
      this.initialDate = this.$options.filters.date(
        e.view.currentStart,
        "YYYY-MM-DD"
      );
      this.endDate = this.$options.filters.date(
        e.view.currentEnd,
        "YYYY-MM-DD"
      );

      this.releaseDate = this.$options.filters.date(
        e.view.currentStart,
        "YYYY-MM-DD"
      );
    },
    OpenModalReport: function (e) {
      e.preventDefault();
      this.initialDate = null;
      this.endDate = null;
      this.validatedReportForm = false;
      this.$bvModal.show("mReport");
    },
    GetReport: function () {
      this.validatedReportForm = true;
      this.$refs.reportValidationForm.validate().then((isValid) => {
        if (isValid) {
          let dateIni = new Date(this.initialDate);
          let dateEnd = new Date(this.endDate);
          if (dateIni > dateEnd) {
            this.$makeToast(
              "Data final não pode ser inferior a Data inicial.",
              "danger",
              "Relatório de Conta Corrente"
            );
            return;
          }
          if (!this.IsValidRangeForReport(dateIni, dateEnd)) {
            this.$makeToast(
              "Período não pode ser maior que 31 dias.",
              "danger",
              "Relatório de Conta Corrente"
            );
            return;
          }

          this.loadingReport = true;
          const params = {
            InitialDate: this.initialDate,
            EndDate: this.endDate,
            "Object.Merchant.Id": this.idMerchant,
          };
          this.$store
            .dispatch("ReportCheckingAccountPeriodInLot", { params: params })
            .then((response) => {
              if (
                response.UrlReport != null &&
                response.UrlReport != undefined &&
                response.UrlReport != ""
              ) {
                this.$makeToast(
                  "Aguarde a conclusão do download",
                  "info",
                  "Relatório gerado com sucesso"
                );
                window.open(response.UrlReport, "_self");
                this.$bvModal.hide("mReport");
              }
            })
            .catch((error) => {
              this.$makeToast(
                "Tente novamente mais tarde.",
                "danger",
                "Erro ao gerar o relatório",
                error
              );
            })
            .finally(() => {
              this.loadingReport = false;
            });
        }
      });
    },
    IsValidRangeForReport: function (initialDate, endDate) {
        let deltaMs = Math.abs(initialDate - endDate);
        let totalDays = deltaMs / (1000 * 60 * 60 * 24);
        if (totalDays > 31)
            return false;
        return true;
    },
    ListCheckingAccount: function () {
      this.loading = true;

      let data = {
        ...{
          InitialDate: this.initialDate,
          EndDate: this.endDate,
          "Object.Merchant.Id": this.idMerchant,
        },
      };
      this.$store
        .dispatch("ListCheckingAccount", { params: data })
        .then((response) => {
          this.events = [];
          response.forEach((element) => {
            let event = {
              title:
                (
                  element.Amount > 0
                  ? "<span style='color: " + (
                    element.IsToday
                    ? "#00304d"
                    : element.TransferStatus != null && (element.TransferStatus.Code == "1" || element.TransferStatus.Code == "2")
                      ? "#f4d438"
                      : element.TransferStatus != null && element.TransferStatus.Code == "3"
                        ? "#0f9f57"
                        : element.TransferStatus != null && (element.TransferStatus.Code == "4" || element.TransferStatus.Code == "5")
                          ? "#FF0000"
                          : element.TransferStatus.Code != ""
                            ? "#f4d438" 
                            : "gray"
                    ) 
                    + "'>" +
                      this.$options.filters.currency(element.Amount) +
                    "</span> <br />"
                  : 
                  element.Amount < 0
                  ?
                    "<span style='color: gray; font-size: 9pt'>" +
                      "Não " + (element.IsTransferred ? "houve depósito" : "haverá depósito") +
                    "</span> <br />" +
                    "<span style='color: red'>" +
                      this.$options.filters.currency(element.Amount) +
                    "</span> <br />" +
                    "<span class='status-contacorrente'>" +
                      "Saldo negativo" +
                    "</span>"
                  : 
                    "<span style='color: gray; font-size: 9pt'>" +
                      "Não " + (element.IsTransferred ? "houve depósito" : "haverá depósito") +
                    "</span>"
                ) 
                +
                (
                  element.Status != "0" && element.Amount > 0
                  ? "<span class='status-contacorrente'>" + element.Status + "</span>" : ""
                ),
              start: element.ReleaseDate,
              allDay: true,
              color: "#ffffff",
            };
            this.events.push(event);
          });
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar a conta corrente de lucro",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/merchantCheckingAccount.vue